import { render, staticRenderFns } from "./Superdrawer.vue?vue&type=template&id=a974da24&"
import script from "./Superdrawer.vue?vue&type=script&lang=js&"
export * from "./Superdrawer.vue?vue&type=script&lang=js&"
import style0 from "./Superdrawer.vue?vue&type=style&index=0&id=a974da24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports